import { CommonService } from '@services/common.service';
import { Component, Input, OnInit, Output } from '@angular/core';
import _ from 'lodash';
import { User } from '@common/models/User';
import { AddProposedBerthComponent } from 'app/vessel-visit-documents/components/add-proposed-berth/add-proposed-berth.component';
import { DialogService } from '@services/dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { VesselVisitDocumentStatusCodes } from '@common/classes/vessel-visit-document-status-codes';
import { UserService } from '@common/services/user.service';

@Component({
    selector: 'app-proposed-berth-grid',
    templateUrl: './proposed-berth-grid.component.html',
    styleUrls: ['./proposed-berth-grid.component.scss']
})
export class ProposedBerthGridComponent implements OnInit {

    @Input() model: any;
    @Input() editMode: boolean;
    @Input() showVersionColumn = false;
    @Input() collectionName = 'berthProposals';
    data = [];
    currentUser: User;

    constructor(protected common: CommonService,        
        protected translateService: TranslateService,
        private dialogService: DialogService,
        private userService: UserService
    ) {

        userService.currentUserSubject.subscribe((value) => {
            this.currentUser = value;
        });
    }

    async ngOnInit() {
        this.applyData();
    }

    async addBerthProposal() {
        const accommodationRequestId = this.model.accommodationRequests[0].id;            

        const data = await this.common.dialogService.open(AddProposedBerthComponent, { size: 'md' },
            dialogRef => dialogRef.accommodationRequestId = accommodationRequestId
        );

        if (data!=null) {            
            this.model?.accommodationRequests[0].berthProposals.push(data);
        }
        
        this.applyData();
    }

    removeBerthProposal(rowId) {
        /*this.model[this.collectionName] = [...this.model[this.collectionName].filter(d => d.id !== rowId)];
        this.applyData();*/
    }

    private applyData() {
        this.data = [
            ...(this.model?.accommodationRequests?.[0]?.berthProposals ?? [])];
    }

    get addBerthVisible(): boolean {
        /*
         check if there are any items created by other users that are not accepted or rejected
         user needs to first accept/reject item before he can add new items
        */
        const hasPendingFromOtherUser = this.model.accommodationRequests?.some(ar =>
            ar.berthProposals?.some(bp =>
                bp.accepted == null && bp.createdById !== this.currentUser.id
            )
        );
        
        if(hasPendingFromOtherUser)
            return false;

        /*
            user is allowed to add only one item while editing and when there are no pending items he created
            and no accepted items             
        */
       
        return !this.data.some(x =>
            x.id === 0 || 
            (x.createdById === this.currentUser.id && x.accepted == null) ||
            x.accepted === true);    
    }

    approveBerthProposal(id: number) {
        const bp = this.findBerthProposal(id); 
        bp.accepted = true;
        this.applyData();
    }

    async rejectBerthProposal(id: number) {
        const data = await this.dialogService.form({
            title: this.translateService.instant('Reject Berth Proposal') as string,
            message: this.translateService.instant(`Are you sure you want to reject berth proposal?
                
                If you proceed, you will need to provide an alternative berth or cancel the accommodation request.`) as string,
            properties: [{ name: 'rejectionRemark', label: 'Rejection Remark' }]
        });
        if (!data) return;
        
        const bp = this.findBerthProposal(id); 
        bp.accepted = false;
        bp.dispatcherNote = data.rejectionRemark;
        this.applyData();                          
    }    

    undoBerthProposal(id: number) {
        const bp = this.findBerthProposal(id);
        bp.accepted = null;
        bp.dispatcherNote = null;
    }    

    isApproveBerthProposalVisible(id: number): boolean {
        if (!this.editMode) return false;
        
        const bp = this.findBerthProposal(id);

        /*
            newly created items or items that current user added cannot be accepted or reject
        */
        if(id === undefined || this.currentUser.id === bp.createdById){
            return false;
        }

        if (this.model.statusId !== VesselVisitDocumentStatusCodes.WaitingAgentApproval && 
            this.model.statusId !== VesselVisitDocumentStatusCodes.WaitingDispatchApproval) {
            return false;
        }        

        // Check if ANY berthProposal has accepted === true
        const anyAccepted = this.model.accommodationRequests?.some(ar =>
            ar.berthProposals?.some(bp => bp.accepted === true)
        );        

        return !anyAccepted && bp.accepted == null;
    }

    isRejectBerthProposalVisible(id: number): boolean{
        if (!this.editMode) return false;

        const bp = this.findBerthProposal(id);

        /*
            newly created items or items that current user added cannot be accepted or reject
        */
        if(id === undefined || this.currentUser.id === bp.createdById){
            return false;
        }

        return this.editMode && 
               (this.model.statusId==VesselVisitDocumentStatusCodes.WaitingAgentApproval || 
                this.model.statusId==VesselVisitDocumentStatusCodes.WaitingDispatchApproval) && 
                bp.accepted == null;
    }

    isUndoBerthProposalVisible(id: number): boolean{
        const bp = this.findBerthProposal(id);
        return this.editMode && bp.accepted != null;
    }

    // helper method to locate the proposal
    private findBerthProposal(id: number) {
        for (const ar of this.model.accommodationRequests) {
            const bp = ar.berthProposals?.find(b => b.id === id);
            if (bp) return bp;
        }
        return null;
    }
}
